import actions from '../action/session'
import CONSTANT from '../constant/session'
import _ from 'underscore'

export default {
  actions,
  state: {
    list: []
  },
  mutations: {
    
  },
}
